export default __webpack_public_path__ + "static/media/profit.daf2c0f4.mp3";